import { cards } from '@/mocks/home';

const cardImages: Record<string, string> = {
  'crd-1': 'https://readdy.ai/api/search-image?query=Dramatic%20entertainment%20news%20illustration%20of%20two%20figures%20in%20conflict%2C%20warm%20red%20and%20dark%20tones%2C%20theatrical%20lighting%2C%20editorial%20magazine%20style%2C%20bold%20graphic%20composition&width=800&height=500&seq=crd-1-51bl&orientation=landscape',
  'crd-2': 'https://readdy.ai/api/search-image?query=Social%20media%20influencer%20office%20chaos%20artistic%20illustration%2C%20warm%20amber%20lighting%2C%20dramatic%20shadows%2C%20modern%20editorial%20design%2C%20content%20creator%20industry%20theme&width=800&height=500&seq=crd-2-51bl&orientation=landscape',
  'crd-3': 'https://readdy.ai/api/search-image?query=Business%20investigation%20dramatic%20illustration%2C%20documents%20and%20money%20flow%20concept%2C%20warm%20dark%20tones%2C%20corporate%20scandal%20theme%2C%20editorial%20financial%20journalism%20style&width=800&height=500&seq=crd-3-51bl&orientation=landscape',
  'crd-4': 'https://readdy.ai/api/search-image?query=Film%20editing%20suite%20dramatic%20scene%2C%20multiple%20screens%20with%20video%20timeline%2C%20warm%20dark%20atmosphere%2C%20cinematic%20lighting%2C%20behind%20the%20scenes%20TV%20production%20style&width=800&height=500&seq=crd-4-51bl&orientation=landscape',
  'crd-5': 'https://readdy.ai/api/search-image?query=AI%20algorithm%20social%20media%20concept%20art%2C%20digital%20manipulation%20theme%2C%20warm%20orange%20and%20dark%20blue%20contrast%2C%20futuristic%20editorial%20illustration%2C%20technology%20controversy%20mood&width=800&height=500&seq=crd-5-51bl&orientation=landscape',
  'crd-6': 'https://readdy.ai/api/search-image?query=Sports%20referee%20controversy%20dramatic%20illustration%2C%20stadium%20atmosphere%20with%20golden%20lights%2C%20dark%20dramatic%20background%2C%20editorial%20sports%20photography%20style%2C%20tension%20and%20drama&width=800&height=500&seq=crd-6-51bl&orientation=landscape',
  'crd-7': 'https://readdy.ai/api/search-image?query=Music%20producer%20studio%20dramatic%20scene%2C%20creative%20plagiarism%20theme%2C%20warm%20dark%20atmosphere%2C%20professional%20audio%20equipment%2C%20editorial%20music%20industry%20journalism%20style&width=800&height=500&seq=crd-7-51bl&orientation=landscape',
};

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading mb-3">
            热门八卦
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-[600px] mx-auto">
            编辑部精心整理的今日热门爆料，每一条都值得细品
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cards.map((card) => (
            <div
              key={card.id}
              className="bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 group cursor-pointer hover:scale-[1.01] transition-transform"
            >
              <div className="relative h-44 md:h-48 overflow-hidden">
                <img
                  src={cardImages[card.id]}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-accent-500 text-white text-xs font-medium">
                    {card.category}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-bold text-foreground-900 text-sm md:text-base leading-snug mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {card.title}
                </h3>
                <p className="text-foreground-600 text-xs md:text-sm leading-relaxed mb-3 line-clamp-2">
                  {card.excerpt}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line w-3.5 h-3.5 flex items-center justify-center"></i>
                    {card.time}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-chat-3-line w-3.5 h-3.5 flex items-center justify-center"></i>
                    {card.comments}评论
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}